import React from 'react';
import GlossaryTerm from './components/GlossaryTerm';
import {
  annotateDodTerms,
  dodGlossaryTerm,
  type DodGlossaryTermId,
} from './dodGlossary';

export default function DodTermText({
  text,
  language = 'en',
  seen,
}: {
  text: string;
  language?: 'en' | 'es';
  seen?: Set<DodGlossaryTermId>;
}) {
  const spanish = language === 'es';
  return (
    <>
      {annotateDodTerms(text, seen).map((chunk, index) => {
        if (!chunk.termId) {
          return <React.Fragment key={`text-${index}`}>{chunk.text}</React.Fragment>;
        }
        const entry = dodGlossaryTerm(chunk.termId);
        return (
          <GlossaryTerm
            key={`${chunk.termId}-${index}`}
            term={spanish ? entry.label.es : entry.label.en}
            definition={spanish ? entry.help.es : entry.help.en}
          >
            {chunk.text}
          </GlossaryTerm>
        );
      })}
    </>
  );
}
